<template>
  <div>

    <div class="order-create__section-label section-label"
         v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
      <div class="admin-edit" @click="editTranslate([
                        'payments_productsContent',
                      ])"></div>
      {{$t('payments_productsContent.localization_value.value')}}
    </div>
    <div class="custom-row">
      <div class="custom-col custom-col--33"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['payments_productsDescription'])"></div>
        <TextareaDefault
            :label="$t('payments_productsDescription.localization_value.value')"
            v-bind:class="{'ui-no-valid': ex.validation.productsDescription}"
            :errorTxt="$t(`${ex.validationTranslate.productsDescription}.localization_value.value`)"
            :error="ex.validation.productsDescription"
            :maxlength="35"
            :caption="'Max 35 symbols'"
            v-model="ex.express.productsDescription"
            @input="checkValidField(ex.validation.productsDescription)"
        />
      </div>
      <div class="custom-col custom-col--33"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['express_comment'])"></div>
        <TextareaDefault
            :label="$t('express_comment.localization_value.value')"
            v-bind:class="{'ui-no-valid': ex.validation.comment}"
            :errorTxt="$t(`${ex.validationTranslate.comment}.localization_value.value`)"
            :error="ex.validation.comment"
            :maxlength="80"
            :caption="'Max 80 symbols'"
            v-model="ex.express.comment"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TextareaDefault from "@/components/UI/textarea/TextareaDefault/TextareaDefault";
export default {
  name: "ProductsDescription",
  components: {TextareaDefault},

  props: {
    ex: Object,
  },

  methods: {
    checkValidField(currentValid = false) {
      if (!currentValid) return
      this.ex.validateProductsDescription()
    },
  },

}
</script>

<style scoped>

</style>